import * as CryptoJS from 'crypto-js';
import { APP_SECRET_KEY } from 'src/services/member-auth/constants';

export const decryptionServer = payloadData => {
  console.log('===> decryptionServer : ', payloadData, ', SECRET :', APP_SECRET_KEY);
  return JSON.parse(CryptoJS.AES.decrypt(payloadData, APP_SECRET_KEY).toString(CryptoJS.enc.Utf8));
};

export const encryptionServer = payloadData => {
  console.log('===> encryptionServer : ', payloadData, ', SECRET :', APP_SECRET_KEY);
  return CryptoJS.AES.encrypt(JSON.stringify(payloadData), APP_SECRET_KEY).toString();
};
